import { decorate, observable, action } from 'mobx';
import * as Api from '../lib/api';

export class FavoritesStore {
    loading = false;
    toggleLoading = false;
    favorites = [];

    getFavorites = () => {
        this.loading = true;

        Api.fetch('user/favorites')
            .then(response => {
                if (response.success) {
                    this.favorites = response.result;
                }
            })
            .finally(() => {
                this.loading = false;
            });
    };

    toggleFavorite = (id, action) => {
        this.toggleLoading = true;

        if (action === 'remove') {
            Api.fetch('user/favorites', { product_id: id }, 'DELETE')
                .then(response => {
                    if (response.success) {
                        this.favorites = this.favorites.filter(favorite => favorite.id !== id);
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        } else {
            Api.fetch('user/favorites', { product_id: id }, 'PUT')
                .then(response => {
                    if (response.success) {
                        // this.favorites = this.favorites.filter(favorite => favorite.id !== id);
                    }
                })
                .finally(() => {
                    this.toggleLoading = false;
                });
        }
    };

    resetStore = () => {
        this.loading = false;
        this.toggleLoading = false;
        this.favorites = [];
    };
}

decorate(FavoritesStore, {
    loading: observable,
    toggleLoading: observable,
    favorites: observable,

    getFavorites: action,
});
